import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UploadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"upload"}/>
}
